import React from 'react';
import { useFamilyContext } from '../../contexts/FamilyContext';
import ManagementCard from './ManagementCard';
import QuickActionGrid from './QuickActionGrid';

export default function KidManageView() {
  const { 
    currentUser, 
    kidAllowances, 
    allowanceJobs, 
    activities 
  } = useFamilyContext();

  // Calculate allowance stats for this kid
  const getAllowanceStats = () => {
    const allowance = kidAllowances[currentUser?.id];
    const balance = allowance?.current_balance || 0;
    
    const availableJobs = allowanceJobs?.filter(job => 
      job.status === 'available' && 
      (!job.target_kid_id || job.target_kid_id === currentUser?.id)
    ).length || 0;

    return [
      { value: `$${balance.toFixed(2)}`, label: 'My Balance' },
      { value: availableJobs, label: 'Available Jobs' }
    ];
  };

  // Calculate activity stats for this kid
  const getActivityStats = () => {
    const kidActivities = activities[currentUser?.id] || [];
    const totalActivities = kidActivities.length;
    
    // Count favorites (you could implement a favorites system)
    const favorites = 5; // Placeholder

    return [
      { value: totalActivities || 23, label: 'Activities' },
      { value: favorites, label: 'My Favorites' }
    ];
  };

  const managementAreas = [
    {
      icon: '💰',
      title: 'My Allowance',
      description: 'See your balance and available jobs to earn more money',
      colorScheme: 'allowance',
      stats: getAllowanceStats(),
      actions: [
        { label: 'View Details', onClick: () => {}, primary: true }
      ],
      to: '/allowance'
    },
    {
      icon: '🎯',
      title: 'Fun Activities',
      description: 'Browse activities and suggest new family fun',
      colorScheme: 'activities',
      stats: getActivityStats(),
      actions: [
        { label: 'Explore', onClick: () => {}, primary: true }
      ],
              to: '/tasks?tab=activities'
    },
    {
      icon: '👤',
      title: 'My Settings',
      description: 'Update your profile and preferences',
      colorScheme: 'settings',
      actions: [
        { label: 'Open', onClick: () => {}, primary: true }
      ],
      to: '/settings'
    }
  ];

  return (
    <div className="kid-manage-view">
      <QuickActionGrid />
      
      <div className="management-grid">
        {managementAreas.map((area, index) => (
          <ManagementCard key={index} {...area} />
        ))}
      </div>
    </div>
  );
}